/* Qapary · ficha de producto: variantes, galería, cantidad, agregar al carrito, anclas, barra móvil */
(function () {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const ficha = q('[data-ficha]');
  if (!ficha) return;

  const form = q('[data-form-producto]', ficha);
  const variantes = JSON.parse(q('[data-variantes-json]', ficha).textContent);
  const stockJson = q('[data-stock-json]', ficha);
  const stockPorVariante = stockJson ? JSON.parse(stockJson.textContent) : {};
  const inputId = q('[data-variante-id]', form);
  const money = (c) => window.qapary.money ? window.qapary.money(c) : 'S/. ' + (c / 100).toFixed(2);
  const opcionTalla = ficha.dataset.opcionTalla;

  /* ---- Opciones elegidas → variante ---- */
  function elegidas() {
    return qa('[data-opcion]', form).map((grupo) => {
      const radio = q('input[type="radio"]:checked', grupo);
      if (radio) return radio.value;
      const sel = q('select', grupo);
      return sel ? sel.value : null;
    });
  }
  function varianteActual() {
    const ops = elegidas();
    return variantes.find((v) => ops.every((o, i) => o === null || v.options[i] === o)) || null;
  }
  function pintar() {
    const v = varianteActual();
    const agregar = q('[data-agregar]', ficha);
    const texto = q('[data-agregar-texto]', agregar);
    const ancla = q('[data-precio-ancla]', ficha), ahorro = q('[data-precio-ahorro]', ficha);
    const colorNombre = q('[data-color-nombre]', ficha);
    const grupoColor = q('.compra__colores', ficha);
    if (grupoColor && colorNombre) { const r = q('input:checked', grupoColor); if (r) colorNombre.textContent = r.value; }
    if (!v) {
      texto.textContent = 'Combinación no disponible';
      agregar.setAttribute('data-agotado', '');
      return;
    }
    inputId.value = v.id;
    q('[data-precio-actual]', ficha).textContent = money(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      ancla.textContent = money(v.compare_at_price); ancla.hidden = false;
      ahorro.textContent = 'Ahorras ' + money(v.compare_at_price - v.price); ahorro.hidden = false;
    } else { ancla.hidden = true; ahorro.hidden = true; }
    const barraTalla = q('[data-barra-talla]', ficha), barraPrecio = q('[data-barra-precio]', ficha);
    if (barraTalla) barraTalla.textContent = q('[data-opcion-es-talla]', ficha) ? 'Talla ' + v.title : v.title;
    if (barraPrecio) barraPrecio.textContent = money(v.price);
    if (v.available) {
      texto.innerHTML = 'Añadir al carrito · <span data-precio-boton>' + money(v.price) + '</span>';
      agregar.removeAttribute('data-agotado');
    } else {
      const tallaSinStock = q('[data-opcion-es-talla] input:checked', ficha);
      texto.textContent = tallaSinStock ? `Agotada en ${tallaSinStock.value}: avísame` : 'Agotada: avísame';
      agregar.setAttribute('data-agotado', '');
    }
    // Cantidad y "Quedan N" con el stock real de la talla elegida (data-stock-json); agotada, sin cantidad.
    const stock = q('[data-stock-texto]', ficha);
    const input = q('[data-stepper-input]', form);
    const cantidad = q('[data-cantidad]', form);
    const hay = stockPorVariante[v.id];
    // Un aviso de tope habla de la talla anterior: se cierra al cambiar de talla.
    document.querySelectorAll('#toasts .toast--aviso').forEach((t) => t.remove());
    if (cantidad) cantidad.hidden = !v.available;
    if (input) {
      if (v.available && typeof hay === 'number' && hay > 0) input.max = hay; else input.removeAttribute('max');
      if (input.max && Number(input.value) > Number(input.max)) input.value = input.max;
      input.dispatchEvent(new Event('sincronizar'));
    }
    if (stock) {
      const umbral = Number(cantidad ? cantidad.dataset.umbral : 0);
      stock.textContent = v.available && typeof hay === 'number' && hay > 0 && hay <= umbral ? `${hay === 1 ? 'Queda 1' : 'Quedan ' + hay} en talla ${v.option1}` : '';
    }
    // foto de la variante
    if (v.featured_media) {
      const foto = qa('[data-foto]', ficha).find((f) => (f.dataset.variantes || '').split(' ').includes(String(v.id)));
      if (foto) mostrarFoto(Number(foto.dataset.foto));
    }
    const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    // Los WhatsApp de ayuda llevan la talla elegida en el mensaje ya escrito.
    const tallaElegida = q('[data-opcion-es-talla] input:checked', ficha);
    if (tallaElegida) qa('[data-whatsapp-talla]').forEach((a) => {
      const texto = a.dataset.plantilla.replace('[talla]', tallaElegida.value);
      a.href = `https://api.whatsapp.com/send?phone=${a.dataset.telefono}&text=${encodeURIComponent(texto)}`;
    });
  }
  qa('[data-opcion] input, [data-opcion] select', form).forEach((el) => el.addEventListener('change', () => { q('.compra__tallas', form)?.classList.remove('compra__tallas--falta'); const at = q('[data-error-talla]', form); if (at) { at.hidden = true; qa('.compra__tallas input', form).forEach((i) => { i.removeAttribute('aria-invalid'); i.removeAttribute('aria-describedby'); }); } error.hidden = true; pintar(); }));

  /* ---- Galería ---- */
  const fotos = qa('[data-foto]', ficha);
  // Fotos diferidas: arrancan cuando termina la primera, así no le quitan red a la imagen que se ve al cargar.
  const diferidas = qa('img[data-diferida]', ficha);
  // Y solo las que la ficha va a mostrar: las que quedan fuera del tope no se bajan nunca.
  const soltar = () => qa('img[data-diferida]', ficha).forEach((img) => {
    const padre = img.closest('[data-foto]');
    if (padre && padre.hidden) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    img.removeAttribute('data-diferida');
  });
  if (diferidas.length) {
    const primera = q('.galeria__foto img[fetchpriority="high"]', ficha);
    if (!primera || primera.complete) soltar();
    else { primera.addEventListener('load', soltar, { once: true }); primera.addEventListener('error', soltar, { once: true }); setTimeout(soltar, 4000); }
  }
  const pista = q('[data-galeria-pista]', ficha);
  function marcarMiniatura(i) {
    qa('[data-miniatura]', ficha).forEach((m, k) => { m.classList.toggle('galeria__miniatura--activa', k === i); if (k === i) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current'); });
  }
  function mostrarFoto(i) {
    fotos.forEach((f, k) => f.classList.toggle('galeria__foto--activa', k === i));
    marcarMiniatura(i);
    qa('[data-punto]', ficha).forEach((p, k) => p.classList.toggle('galeria__punto--activo', k === i));
    if (pista && window.matchMedia('(max-width: 1023px)').matches) pista.scrollTo({ left: fotos[i].offsetLeft, behavior: 'smooth' });
    const actual = q('[data-galeria-actual]', ficha); if (actual) actual.textContent = visibles().indexOf(fotos[i]) + 1;
  }
  const visibles = () => fotos.filter((f) => !f.hidden);
  if (fotos.length) mostrarFoto(fotos.findIndex((f) => !f.hidden));
  qa('[data-miniatura]', ficha).forEach((m) => m.addEventListener('click', () => mostrarFoto(Number(m.dataset.miniatura))));

  /* Cuáles fotos entran. La ficha muestra un tope (4 por defecto) y se prefieren las que tienen
     fondo: un packshot sobre blanco tiene el borde casi blanco, y eso sí se puede medir. Se mide
     sobre una copia de 48 px (data-muestra, unos pocos KB). Si el navegador no deja leer el canvas,
     todas puntúan igual y quedan las primeras, que es lo que el HTML ya trae visible. */
  const maxFotos = Number(q('[data-galeria]', ficha)?.dataset.galeriaMax || 0);
  if (maxFotos > 0 && fotos.length > maxFotos) {
    const blancura = (src) => new Promise((listo) => {
      if (!src) { listo(1); return; }
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onerror = () => listo(1);
      img.onload = () => {
        try {
          const L = 24, lienzo = document.createElement('canvas');
          lienzo.width = L; lienzo.height = L;
          const cx = lienzo.getContext('2d', { willReadFrequently: true });
          cx.drawImage(img, 0, 0, L, L);
          const d = cx.getImageData(0, 0, L, L).data;
          let borde = 0, claros = 0;
          for (let y = 0; y < L; y += 1) {
            for (let x = 0; x < L; x += 1) {
              if (x > 3 && x < L - 4 && y > 3 && y < L - 4) continue;
              const p = (y * L + x) * 4;
              borde += 1;
              if (Math.min(d[p], d[p + 1], d[p + 2]) > 232) claros += 1;
            }
          }
          listo(borde ? claros / borde : 1);
        } catch (e) { listo(1); }
      };
      img.src = src;
    });
    Promise.all(fotos.map((f) => blancura(f.dataset.muestra))).then((puntajes) => {
      const elegidas = fotos
        .map((f, i) => ({ i, p: puntajes[i] }))
        .sort((a, b) => a.p - b.p || a.i - b.i)
        .slice(0, maxFotos)
        .map((x) => x.i)
        .sort((a, b) => a - b);
      const minis = qa('[data-miniatura]', ficha);
      const puntos = qa('[data-punto]', ficha);
      fotos.forEach((f, i) => {
        const dentro = elegidas.indexOf(i) !== -1;
        f.hidden = !dentro;
        if (minis[i] && minis[i].parentElement) minis[i].parentElement.hidden = !dentro;
        if (puntos[i]) puntos[i].hidden = !dentro;
      });
      elegidas.forEach((i, k) => { if (minis[i]) minis[i].setAttribute('aria-label', 'Ver foto ' + (k + 1) + ' de ' + elegidas.length); });
      soltar();
      mostrarFoto(elegidas[0]);
    });
  }
  if (pista) pista.addEventListener('scroll', () => {
    if (!window.matchMedia('(max-width: 1023px)').matches) return;
    const i = Math.round(pista.scrollLeft / pista.clientWidth);
    qa('[data-punto]', ficha).forEach((p, k) => p.classList.toggle('galeria__punto--activo', k === i));
    const actual = q('[data-galeria-actual]', ficha); if (actual) actual.textContent = i + 1;
  }, { passive: true });
  // Escritorio: si el bloque de compra es más alto que la pantalla, se fija más arriba para que su pie quede a la vista.
  const compra = q('.compra', ficha);
  const ajustarCompra = () => {
    if (!compra || !window.matchMedia('(min-width: 1024px)').matches) return;
    const cabecera = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-alto')) || 80;
    const arriba = Math.min(cabecera + 24, window.innerHeight - compra.offsetHeight - 24);
    compra.parentElement.style.setProperty('--compra-top', arriba + 'px');
  };
  ajustarCompra();
  window.addEventListener('resize', ajustarCompra);
  // La columna crece al elegir tallas en "Combina con" o al cargar las fuentes: se recalcula con su alto real.
  if (compra && 'ResizeObserver' in window) new ResizeObserver(ajustarCompra).observe(compra);
  // Zoom: se cierra también deslizando hacia abajo (además del botón y Escape).
  const zoom = q('#zoom');
  if (zoom) {
    let y0 = null;
    zoom.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; }, { passive: true });
    zoom.addEventListener('touchend', (e) => { if (y0 !== null && e.changedTouches[0].clientY - y0 > 80) window.qapary.paneles.cerrar(); y0 = null; }, { passive: true });
  }
  // Zoom a pantalla completa con anterior / siguiente y contador. Solo recorre las fotos que la
  // ficha está mostrando: las que quedaron fuera del tope no existen para la clienta.
  const botonesZoom = () => qa('[data-zoom]', ficha).filter((b) => { const f = b.closest('[data-foto]'); return !f || !f.hidden; });
  let zoomActual = 0;
  function pintarZoom(i) {
    const lista = botonesZoom();
    if (!lista.length) return;
    zoomActual = (i + lista.length) % lista.length;
    const b = lista[zoomActual];
    const img = q('[data-zoom-img]'); img.src = b.dataset.zoom; img.alt = q('img', b)?.alt || '';
    const n = q('[data-zoom-actual]'); if (n) n.textContent = zoomActual + 1;
    q('.modal__zoom')?.classList.remove('zoom--ampliado');
    q('[data-zoom-alternar]')?.setAttribute('aria-pressed', 'false');
  }
  const lienzoZoom = q('[data-zoom-lienzo]');
  const alternarZoom = q('[data-zoom-alternar]');
  if (lienzoZoom && alternarZoom) alternarZoom.addEventListener('click', () => {
    // Botón: funciona con dedo, mouse y Enter. Ampliada, el lienzo toma el foco y las flechas la recorren.
    const caja = q('.modal__zoom'); const ampliado = caja.classList.toggle('zoom--ampliado');
    alternarZoom.setAttribute('aria-pressed', String(ampliado));
    if (ampliado) requestAnimationFrame(() => { lienzoZoom.scrollLeft = (lienzoZoom.scrollWidth - lienzoZoom.clientWidth) / 2; lienzoZoom.scrollTop = (lienzoZoom.scrollHeight - lienzoZoom.clientHeight) / 2; });
  });
  qa('[data-zoom]', ficha).forEach((b) => b.addEventListener('click', () => { pintarZoom(botonesZoom().indexOf(b)); window.qapary.paneles.abrir('zoom'); }));
  qa('[data-zoom-paso]').forEach((b) => b.addEventListener('click', () => pintarZoom(zoomActual + Number(b.dataset.zoomPaso))));
  document.addEventListener('keydown', (e) => {
    const z = q('#zoom'); if (!z || z.hidden) return;
    const caja = q('.modal__zoom');
    if (caja && caja.classList.contains('zoom--ampliado')) {
      // Ampliada: las flechas recorren la foto.
      const paso = 80, l = q('[data-zoom-lienzo]');
      const d = { ArrowRight: [paso, 0], ArrowLeft: [-paso, 0], ArrowDown: [0, paso], ArrowUp: [0, -paso] }[e.key];
      if (d && l) { e.preventDefault(); l.scrollBy(d[0], d[1]); }
      return;
    }
    if (e.key === 'ArrowRight') pintarZoom(zoomActual + 1);
    if (e.key === 'ArrowLeft') pintarZoom(zoomActual - 1);
  });

  /* ---- Stepper ---- */
  qa('[data-stepper]', ficha).forEach((st) => {
    const input = q('[data-stepper-input]', st);
    const menos = q('[data-stepper-menos]', st), mas = q('[data-stepper-mas]', st);
    // El aviso de tope sale solo cuando la persona pide más de lo que hay, nunca al cargar ni al cambiar de talla.
    const ajustar = (pidioMas = false) => {
      const min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity;
      const pedido = Number(input.value || 1);
      const v = Math.min(Math.max(pedido, min), max);
      input.value = v; menos.disabled = v <= min;
      if (pidioMas && pedido > max) window.qapary.toast(`Solo hay ${max} en esta talla`, { tono: 'aviso' });
    };
    menos.addEventListener('click', () => { input.value = Number(input.value) - 1; ajustar(); });
    mas.addEventListener('click', () => { input.value = Number(input.value) + 1; ajustar(true); });
    input.addEventListener('change', () => ajustar(true));
    input.addEventListener('sincronizar', () => ajustar());
    ajustar();
  });

  /* ---- Agregar al carrito ---- */
  const error = q('[data-error]', ficha);
  function mostrarError(msg) { q('span', error).textContent = msg; error.hidden = false; error.scrollIntoView({ block: 'nearest' }); }
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    error.hidden = true;
    const agregar = q('[data-agregar]', ficha);
    const grupoTalla = q('.compra__tallas', form);
    if (grupoTalla && !q('input:checked', grupoTalla)) {
      // Sin talla: se marca el grupo, se lleva la vista hasta él, se anuncia (role="alert") y el foco va al grupo.
      grupoTalla.classList.add('compra__tallas--falta');
      const avisoTalla = q('[data-error-talla]', grupoTalla);
      if (avisoTalla) {
        avisoTalla.hidden = false;
        qa('input', grupoTalla).forEach((i) => { i.setAttribute('aria-invalid', 'true'); i.setAttribute('aria-describedby', avisoTalla.id); });
      } else mostrarError('Elige tu talla para agregarla al carrito.');
      grupoTalla.scrollIntoView({ block: 'center', behavior: 'smooth' });
      // El foco va al grupo (no a una talla: un anillo sobre S se leía como talla elegida); con Tab se entra a las tallas.
      grupoTalla.setAttribute('tabindex', '-1');
      grupoTalla.focus({ preventScroll: true });
      return;
    }
    const v = varianteActual();
    if (!v) { mostrarError('Elige color y talla para continuar.'); return; }
    if (!v.available) {
      const tallaIdx = qa('[data-opcion]', form).findIndex((g) => g.classList.contains('compra__tallas'));
      const talla = tallaIdx >= 0 ? elegidas()[tallaIdx] : v.title;
      const t = q('[data-avisame-talla]'); if (t) t.textContent = talla ? 'la talla ' + talla : '';
      const tags = q('[data-avisame-tags]'); if (tags) tags.value = 'avisame, avisame:' + ficha.dataset.productoHandle + ':' + (talla || v.id);
      const nota = q('[data-avisame-nota]'); if (nota) nota.value = 'Avísame: ' + document.title + ' · ' + v.title;
      window.qapary.paneles.abrir('avisame');
      return;
    }
    const textoBoton = q('[data-agregar-texto]', agregar);
    const textoAntes = textoBoton.innerHTML;
    agregar.classList.add('boton--cargando');
    agregar.setAttribute('aria-busy', 'true');
    agregar.disabled = true;
    textoBoton.textContent = 'Agregando…';
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      const res = await fetch(window.qapary.rutas.cart_add + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) { mostrarError(data.description || data.message || 'No se pudo agregar. Intenta de nuevo.'); return; }
      if (data.sections && data.sections['cart-drawer']) window.qapary.carrito.reemplazar(data.sections['cart-drawer']);
      else await window.qapary.carrito.refrescar();
      window.qapary.paneles.abrir('carrito', agregar);
    } catch (err) {
      mostrarError('Sin conexión. Revisa tu red e intenta de nuevo.');
    } finally { agregar.classList.remove('boton--cargando'); agregar.removeAttribute('aria-busy'); agregar.disabled = false; textoBoton.innerHTML = textoAntes; }
  });

  /* ---- Barra fija móvil: reenvía el clic al botón real ---- */
  const barra = q('[data-barra-compra]', ficha);
  const agregarReal = q('[data-agregar]', ficha);
  if (barra && agregarReal && 'IntersectionObserver' in window) {
    // Aparece solo cuando el botón real ya quedó arriba, fuera de pantalla; nunca antes de verlo.
    const io = new IntersectionObserver(([en]) => {
      barra.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
      document.documentElement.classList.toggle('con-barra-compra', !barra.hidden);
      if (!barra.hidden) document.documentElement.style.setProperty('--barra-compra-alto', barra.offsetHeight + 'px');
    }, { threshold: 0 });
    io.observe(agregarReal);
    const botonBarra = q('[data-barra-agregar]', barra);
    const sincronizar = () => { botonBarra.textContent = agregarReal.hasAttribute('data-agotado') ? 'Avísame' : 'Añadir'; };
    new MutationObserver(sincronizar).observe(agregarReal, { attributes: true, attributeFilter: ['data-agotado'] });
    sincronizar();
    botonBarra.addEventListener('click', () => agregarReal.click());
  }

  /* ---- Envío estimado ---- */
  const zona = q('[data-envio-zona]', ficha), envioTexto = q('[data-envio-texto]', ficha);
  if (zona && envioTexto) zona.addEventListener('change', () => { envioTexto.textContent = envioTexto.dataset[zona.value] || ''; });

  /* ---- Anclas: sección activa ---- */
  const anclas = qa('[data-anclas] a');
  if (anclas.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entradas) => {
      entradas.forEach((en) => { if (en.isIntersecting) anclas.forEach((a) => a.setAttribute('aria-current', a.getAttribute('href') === '#' + en.target.id)); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    anclas.forEach((a) => { const t = q(a.getAttribute('href')); if (t) io.observe(t); });
  }

  /* ---- Recomendaciones (Shopify) ---- */
  const reco = q('[data-recomendaciones]');
  // Si el render del servidor dejó la grilla vacía (sin complementos con stock), se oculta la sección.
  if (reco && !q('[data-recomendaciones-grilla] .card', reco)) {
    fetch(reco.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grilla = q('[data-recomendaciones-grilla]', doc);
      if (grilla && q('.card', grilla)) { q('[data-recomendaciones-grilla]', reco).innerHTML = grilla.innerHTML; if (window.qapary.sincronizarRapido) window.qapary.sincronizarRapido(); }
      else reco.hidden = true;
    }).catch(() => { reco.hidden = true; });
  }
})();
